<p-message
    severity="contrast"
    variant="text"
    closeable
    class="text-center"
    styleClass="w-full text-center !rounded-none">
    <ng-template #container>
        <div class="w-full flex items-center justify-center" (click)="timeSyncInfo()">
            <div>
                <span class="font-semibold"> WARNING:</span> Your system time may be out of sync
            </div>
            <div class="ml-1 mt-0.5">
                <fa-icon class="cursor-pointer" [icon]="faCircleInfo"></fa-icon>
            </div>
        </div> </ng-template
></p-message>
